// extracted by mini-css-extract-plugin
export default {"flag":"LanguagePickerIcon_flag__-Q00J"};